import { Button } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Actions from '../../../../actions'
import Dialog from '../../../common/Dialog'

const TerminateBotDialog = () => {
  const dispatch = useDispatch()
  const shouldDisplayTerminateBotAlert = useSelector(
    state => state.getCare.shouldDisplayTerminateBotAlert
  )
  const navigateFromBot = useSelector(state => state.getCare.navigateFromBot)

  const closeTerminateBotAlert = () => {
    dispatch(
      Actions.createAction(Actions.TERMINATE_BOT_POPUP, { isVisible: false })
    )
  }

  const onExitBot = () =>
    dispatch(Actions.createAction(Actions.NAVIGATION_FROM_BOT, navigateFromBot))

  return (
    <Dialog
      closable={true}
      title={$t('dialogs.closeBot.title')}
      isVisible={shouldDisplayTerminateBotAlert}
      onCancel={closeTerminateBotAlert}
      footerActions={[
        <Button
          key="2"
          className="dialog-action trackable"
          data-name="cancel"
          onClick={closeTerminateBotAlert}
          type="primary"
        >
          {$t('common.cancel')}
        </Button>,
        <Button
          key="1"
          className="dialog-action trackable"
          data-name="exit bot"
          onClick={() => {
            onExitBot()
            closeTerminateBotAlert()
          }}
        >
          {$t('dialogs.closeBot.exit')}
        </Button>,
      ]}
    >
      <div>{$t('dialogs.closeBot.subtitle')}</div>
    </Dialog>
  )
}

export default TerminateBotDialog
